import { logUsage } from 'owa-analytics';
import { getStore } from '../store/store';
import { ValidatedAttachmentType } from '../store/schema/ValidatedAttachmentType';

export async function logSharingIssueDataPoint(composeId: string) {
    const store = getStore();
    const telemetryData = store.telemetryDataForFailedValidation.get(composeId);

    if (telemetryData) {
        const sharingIssueData = telemetryData[ValidatedAttachmentType.SharingIssue];

        if (sharingIssueData) {
            const forceSend = sharingIssueData.forceSend;
            const sharingTipId = sharingIssueData.sharingTipId;
            const errorSource = sharingIssueData.errorSource;
            const totalLinkCount = sharingIssueData.totalLinkCount; // the total # of links with sharing issue while sending message
            const newLinkCount = sharingIssueData.newLinkCount;

            logUsage('SharingIssueTriggered', {
                forceSend: forceSend,
                sharingTipId: sharingTipId,
                errorSource: errorSource,
                totalLinkCount: totalLinkCount,
                newLinkCount: newLinkCount,
            });
        }
    }
}
